<template>
    <div class="container">
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="iconfont icon-yonghu"></i> 用户管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>管理员</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div>
            <div class="handle-box" style="padding-left: 10px">
                <!-- <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >批量删除</el-button>-->
                <el-button type="primary" icon="el-icon-circle-plus-outline" class="handle-del mr10"
                    @click="addUserVisible = true">增加用户</el-button>
                <el-select v-model="query.searchTag" class="handle-select mr10">
                    <el-option key="1" label="姓名" value="name"></el-option>
                    <el-option key="2" label="手机号" value="phone"></el-option>
                </el-select>
                <el-input v-model="query.searchValue" placeholder="请输入搜索内容" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-refresh-right" @click="handleResetSearch">重置</el-button>
            </div>

            <mscard class="projcetCard">
                <template v-slot:header>
                    <div class="cardTitle">管理员列表</div>
                    <!-- <div class="cardTitle">企业列表 - {{ deviceListData[0].projectId }}</div> -->
                </template>
                <template v-slot:body>
                    <table class="projectStyle" cellspacing="0">
                        <tr class="projectHeader" style="text-align: center">
                            <th>姓名</th>
                            <th>手机号</th>
                            <th>注册时间</th>
                            <th>更新时间</th>
                            <th>操作</th>
                        </tr>
                        <tr v-for="(item, index) in tableData" :key="index"
                            :class="selectDevice == index ? 'projectBody selcetBgc' : 'projectBody'"
                            style="text-align: center">
                            <td>{{ item.name }}</td>
                            <td>{{ item.phone }}</td>
                            <td>{{ item.createtime }}</td>
                            <td>{{ item.updatetime }}</td>
                            <td class="moreDeviceDetail">
                                <el-button type="text" @click="queryBindCompany(index, item)">查看绑定企业</el-button>
                                <el-button type="text" @click="editUser(index, item)">编辑</el-button>
                                <el-button type="text" @click="resetPassword(index, item)">重置密码</el-button>
                                <el-button type="text" class="red" @click="handleDelete(index, item)">删除</el-button>
                            </td>
                        </tr>
                    </table>
                </template>
            </mscard>

            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
                    :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="70px">
                <el-form-item label="用户名">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 增加用户弹出框 -->
        <el-dialog title="增加用户" :visible.sync="addUserVisible" width="30%">
            <el-form ref="form" :model="addUserform" label-width="80px">
                <el-form-item label="姓名">
                    <el-input v-model="addUserform.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="addUserform.phone" type="number"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onAddUser">立即创建</el-button>
                    <el-button @click="addUserVisibleClose">关 闭</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 查看绑定企业弹窗 -->
        <el-dialog title="查看绑定企业" :visible.sync="companyVisible" width="50%">
            <el-table :data="companyTableData" style="width: 100%">
                <el-table-column prop="companyName" label="企业名称"></el-table-column>
                <el-table-column prop="bindData" label="绑定时间"></el-table-column>
                <el-table-column prop="companyCreateData" label="企业创建时间"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="companyVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    AllCompany,
    AddCompany,
    QueryUserCompany,
    QueryCompanyUser,
    QueryUser,
    QueryCompanyProject,
    QueryProjectName,
    DeleteCompany,
    GetAllUser,
    AddUser,
    QueryCompanyInfo,
    EditUserName,
    ResetUserPassword,
    DeleteUser,
    SearchUser
} from '../../api/index';
import moment from 'moment';
import mscard from '@/components/common/dashBoard/msCard.vue';
export default {
    name: 'basetable',
    data() {
        return {
            // 增加用户弹窗
            addUserVisible: false,
            //增加用户信息
            addUserform: {
                name: '',
                phone: ''
            },
            // 绑定企业弹窗展示
            companyVisible: false,
            // 绑定企业信息
            companyTableData: [],

            query: {
                searchTag: 'name',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1
        };
    },
    created() {
        this.getData();
    },
    methods: {
        // 重置搜索
        handleResetSearch() {
            this.query = {
                searchTag: 'name',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            };
            this.getData();
        },
        // 重置密码
        async resetPassword(index, row) {
            let that = this;
            this.$confirm('此操作将会重置用户密码为初始密码, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const result = await ResetUserPassword({ id: row.id });
                    if (result.code !== 200) {
                        return;
                    }
                    that.$message.success('重置密码成功');
                })
                .catch(() => { });
        },
        // 编辑用户信息
        async editUser(index, row) {
            this.$prompt('编辑用户姓名', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: row.name
            })
                .then(async ({ value }) => {
                    let inputValue = value.trim();
                    if (inputValue == '') {
                        this.$message.warning('请输入正确名称');
                        return;
                    }

                    // 修改用户名称
                    let result = await EditUserName({ id: row.id, name: inputValue });
                    if (result.code !== 200) {
                        return;
                    }
                    this.$message.success('修改成功');
                    this.getData();
                })
                .catch(() => { });
        },
        // 查看绑定企业
        async queryBindCompany(index, row) {
            const result = await QueryCompanyUser({ id: row.id });
            console.log('绑定的企业列表');
            console.log(result.data);
            if (result.code !== 200) {
                return;
            }
            this.companyVisible = true;
            let tableData = [];
            // 根据企业ID查询企业信息
            for (let i = 0; i < result.data.length; i++) {
                let companyInfo = await QueryCompanyInfo({ id: result.data[i].companyId });
                tableData.push({
                    companyName: companyInfo.data.name,
                    bindData: moment(result.data[i].createTime * 1).format('YYYY-MM-DD HH:mm:ss'),
                    companyCreateData: moment(companyInfo.data.createTime * 1).format('YYYY-MM-DD HH:mm:ss')
                });
                console.log('根据id查询的信息');
                console.log(companyInfo);
            }
            this.companyTableData = tableData;
        },
        // 删除用户
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确认删除该用户吗?', '提示', {
                type: 'warning'
            })
                .then(async () => {
                    // 确认删除用户
                    const result = await DeleteUser({ id: row.id });
                    if (result.code !== 200) {
                        return;
                    }
                    this.$message.success('删除成功');
                    this.getData();
                })
                .catch(() => { });
        },

        // 增加用户
        async onAddUser() {
            console.log(this.addUserform);
            let name = this.addUserform.name.trim();
            let phone = this.addUserform.phone.trim();
            if (name == '' || phone == '' || phone.length !== 11) {
                this.$message.warning('请检查输入是否正确');
                return;
            }
            const result = await AddUser({ name, phone });
            if (result.code !== 200) {
                return;
            }
            this.$message.success('增加成功');
            this.addUserform = {
                name: '',
                phone: ''
            };
            this.addUserVisible = false;
            this.getData();
        },
        // 关闭增加用户
        addUserVisibleClose() {
            this.addUserform = {
                name: '',
                phone: ''
            };
            this.addUserVisible = false;
        },

        async getData() {
            let searchTag = this.query.searchTag.trim();
            let searchValue = this.query.searchValue.trim();
            const { data } = await GetAllUser({
                searchTag,
                searchValue: searchValue ? searchValue : '%',
                limit: this.query.pageSize,
                offset: this.query.pageIndex - 1
            });
            console.log(data);
            this.pageTotal = data.count;
            let dataArr = [];
            data.rows.forEach((item) => {
                let obj = item;
                item.createtime = moment(item.createTime * 1).format('YYYY-MM-DD HH:mm:ss');
                item.updatetime = moment(item.updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
                dataArr.push(obj);
            });
            console.log(dataArr);
            this.tableData = dataArr;
        },

        // 触发搜索按钮
        async handleSearch() {
            let searchTag = this.query.searchTag.trim();
            let searchValue = this.query.searchValue.trim();
            if (searchTag == '' || searchValue == '') {
                this.$message.warning('请检查输入');
                return;
            }
            // 开始搜索用户
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    },
    components: {
        mscard
    }
};
</script>

<style scoped lang="less">
@import '../../assets/css/variables.less';

// 修改弹窗样式 ---开始--
/deep/ .el-dialog__header {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__title {
    color: #fff;
}

/deep/ .el-dialog__body {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__footer {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table th {
    background-color: @black-two !important;
    color: @gray-one;
}

/deep/ .el-table tr {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table tr:hover {
    background: @black-three !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: none;
}

/deep/ .el-table__empty-block {
    background-color: @black-two;

    border: none;
}

/deep/ .el-table__empty-text {
    color: #fff;
}

/deep/ .el-button--text {
    color: @gray-one;
}

/deep/ .el-button--text:hover {
    color: #fff;
}

/deep/ .el-button--primary {
    background-color: @black-three;
    color: #fff;
    border: none;
    transition: all 0.5s;
}

/deep/ .el-button--primary:hover {
    background-color: #fff;
    color: @black-three;
    border: none;
}

/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
    color: #fff;
}

/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border: none !important;
}

// 修改弹窗样式 ---结束--

.handle-box {
    margin-bottom: 20px;
    margin-top: -20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
